import { Component } from '@angular/core';

@Component({
  selector: 'app-user-type',
  templateUrl: './user-type.component.html',
  styleUrls: ['./user-type.component.scss']
})
export class UserTypeComponent {

  public params: any;

  agInit(params: any): void {
    this.params = params.data;
  }

}
